var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"async-html",rawName:"v-async-html",value:(_vm.page),expression:"page"}],on:{"load":function($event){return _vm.load()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }